<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — ESTOQUE CONSOLIDADO" titleIcon="fas fa-warehouse">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" v-if="ehSmed">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Buscar produto (nome ou código)">
                            <el-input v-model="filtro.busca" placeholder="Pesquisar produto..." @keyup.native.enter="load(1)" clearable @clear="load(1)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Grupo">
                            <el-select v-model="filtro.grupo_id" placeholder="Todos" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" style="padding-top: 30px;" class="u-text-right">
                        <el-checkbox v-model="filtro.incluir_zerados" @change="load(1)" class="u-mr-10">Incluir saldo zerado</el-checkbox>
                        <el-button type="info" plain icon="el-icon-printer" @click="imprimir">IMPRIMIR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 110px;">Código</th>
                            <th>Produto</th>
                            <th class="hidden-mobile">Grupo</th>
                            <th class="hidden-mobile">Instituição</th>
                            <th style="width: 150px;" class="u-text-right">Saldo em estoque</th>
                            <th style="width: 120px;" class="u-text-right hidden-mobile">Mínimo</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="(item, idx) in items" :key="idx">
                            <td>{{ item.codigo }}</td>
                            <td class="u-uppercase">
                                {{ item.produto_nome }}
                                <el-tag v-if="abaixoMinimo(item)" size="mini" type="danger" class="u-ml-5">abaixo do mínimo</el-tag>
                            </td>
                            <td class="hidden-mobile">{{ item.grupo_nome || '—' }}</td>
                            <td class="hidden-mobile">{{ item.instituicao_nome || '—' }}</td>
                            <td class="u-text-right">
                                <strong :style="{ color: abaixoMinimo(item) ? '#f56c6c' : (Number(item.saldo) <= 0 ? '#f56c6c' : '#303133') }">
                                    {{ Number(item.saldo).toFixed(3) }} {{ item.unidade_medida }}
                                </strong>
                            </td>
                            <td class="u-text-right hidden-mobile">{{ Number(item.estoque_minimo) > 0 ? Number(item.estoque_minimo).toFixed(3) : '—' }}</td>
                        </tr>
                        <tr v-if="!items.length"><td colspan="6" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum item em estoque encontrado.</td></tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        grupos: [],
        filtro: { instituicao_id: '', busca: '', grupo_id: '', incluir_zerados: false },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
        this.carregarGrupos()
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            const payload = {
                instituicao_id: this.filtro.instituicao_id || '',
                busca: this.filtro.busca || '',
                grupo_id: this.filtro.grupo_id || '',
                incluir_zerados: this.filtro.incluir_zerados ? 1 : ''
            }
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/consolidado?page=${this.paginate.page}`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        abaixoMinimo (item) {
            return Number(item.estoque_minimo) > 0 && Number(item.saldo) < Number(item.estoque_minimo)
        },
        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/almox-estoque/imprimir-consolidado',
                param: {
                    instituicao_id: this.filtro.instituicao_id || '',
                    busca: this.filtro.busca || '',
                    grupo_id: this.filtro.grupo_id || '',
                    incluir_zerados: this.filtro.incluir_zerados ? 1 : '',
                    abaixo_minimo: this.filtro.abaixo_minimo ? 1 : ''
                }
            })
        }
    }
}
</script>
